import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MOCK_STATUS, MOCK_URL_MILES_CONVERSION_RATE, URL_MILES_CONVERSION_RATE, URL_MILES_USE_MILES, URL_ADD_MILES_DISCOUNT, URL_REMOVE_MILES_DISCOUNT, } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRAMilesService = /** @class */ (function () {
    function INDRAMilesService(api, http) {
        this.api = api;
        this.http = http;
        this.flightDetails = [];
        this.conversionRates = [];
        this.conversionRates$ = new BehaviorSubject([]);
        this._triggerUseMiles = new BehaviorSubject(false);
        this.triggerUseMiles$ = this._triggerUseMiles.asObservable();
    }
    INDRAMilesService.prototype.INDRA_getMilesConversionRates = function () {
        var _this = this;
        var apiRequest;
        if (MOCK_STATUS.MILES_CONVERSION_RATE) {
            apiRequest = this.http.get(MOCK_URL_MILES_CONVERSION_RATE);
        }
        else {
            apiRequest = this.api.INDRA_get(URL_MILES_CONVERSION_RATE);
        }
        apiRequest.subscribe(function (response) {
            if (response && response.status === '200' && response.conversionRates && response.conversionRates.length) {
                _this.conversionRates = response.conversionRates;
                _this.conversionRates$.next(response.conversionRates);
            }
            else {
                _this.conversionRates = [];
                _this.conversionRates$.next([]);
            }
        });
    };
    INDRAMilesService.prototype.INDRA_convertToMiles = function (cash) {
        var currencyRatio = this.conversionRates[this.conversionRates.length - 1].currencyRatio;
        var ruleRatio = this.conversionRates[this.conversionRates.length - 1].ruleRatio;
        var miles = cash * (currencyRatio * ruleRatio);
        return parseFloat(miles.toFixed(0));
    };
    INDRAMilesService.prototype.INDRA_convertToCash = function (miles) {
        var currencyRatio = this.conversionRates[this.conversionRates.length - 1].currencyRatio;
        var ruleRatio = this.conversionRates[this.conversionRates.length - 1].ruleRatio;
        var cash = miles / (currencyRatio * ruleRatio);
        return parseFloat(cash.toFixed(2));
    };
    INDRAMilesService.prototype.INDRA_getMaxConversion = function (cashToBePaid, userMiles) {
        var maxConversion = 0;
        var maxConvertedCash = 0;
        if (this.INDRA_convertToCash(userMiles) > cashToBePaid || !userMiles) {
            maxConversion = this.INDRA_convertToMiles(cashToBePaid);
            maxConvertedCash = cashToBePaid;
        }
        else {
            maxConversion = userMiles;
            maxConvertedCash = this.INDRA_convertToCash(userMiles);
        }
        return { maxConversion: maxConversion, maxConvertedCash: maxConvertedCash };
    };
    INDRAMilesService.prototype.INDRA_convertSelectedPriceFromFlight = function (cashToBePaid, cashToConvert) {
        var convertedPrice = 0;
        // get percentage of selected price from total flight price
        var limit = parseFloat(((+cashToConvert / cashToBePaid) * 100).toFixed(0));
        if (limit) {
            // get applicable conversion rate
            var currencyRatio_1 = 0;
            var ruleRatio_1 = 0;
            var conversionRate = this.conversionRates;
            if (conversionRate.length && limit >= conversionRate[0].minLimit) {
                conversionRate.forEach(function (rate) {
                    if (limit >= rate.minLimit) {
                        ruleRatio_1 = rate.ruleRatio;
                        currencyRatio_1 = rate.currencyRatio;
                    }
                });
                if (!currencyRatio_1) {
                    currencyRatio_1 = conversionRate[0].currencyRatio;
                }
                if (!ruleRatio_1) {
                    ruleRatio_1 = conversionRate[0].finalRaiot;
                }
            }
            if (currencyRatio_1 && ruleRatio_1) {
                // convert selected price based on currency ratio
                convertedPrice = cashToConvert * (currencyRatio_1 * ruleRatio_1);
            }
        }
        return parseFloat(convertedPrice.toFixed(0));
    };
    // not used
    INDRAMilesService.prototype.INDRA_calculateNewPriceToBePaid = function (cashToBePaid, priceToConvert) {
        var newCashTobePaid = 0;
        // get percentage of selected price from total flight price
        var limit = parseFloat(((+priceToConvert / cashToBePaid) * 100).toFixed(0));
        if (limit) {
            // get applicable conversion rate
            var currencyRatio_2 = 0;
            var conversionRate = this.conversionRates;
            if (conversionRate.length && limit >= conversionRate[0].minLimit) {
                conversionRate.forEach(function (rate) {
                    if (limit >= rate.minLimit) {
                        currencyRatio_2 = rate.currencyRatio;
                    }
                });
                if (!currencyRatio_2) {
                    currencyRatio_2 = conversionRate[0].currencyRatio;
                }
            }
            if (currencyRatio_2) {
                // convert selected price based on currency ratio
                var priceToDeduct = cashToBePaid * (limit / 100) * currencyRatio_2;
                newCashTobePaid = parseFloat((cashToBePaid - priceToDeduct).toFixed(2));
            }
        }
        return newCashTobePaid;
    };
    INDRAMilesService.prototype.INDRA_updateMiles = function (cash) {
        return this.api.INDRA_post("" + URL_MILES_USE_MILES + cash, {});
    };
    INDRAMilesService.prototype.INDRA_addMilesDiscount = function () {
        return this.api.INDRA_post("" + URL_ADD_MILES_DISCOUNT, {});
    };
    INDRAMilesService.prototype.INDRA_removeMilesDiscount = function () {
        return this.api.INDRA_post("" + URL_REMOVE_MILES_DISCOUNT, {});
    };
    INDRAMilesService.prototype.INDRA_setTriggerUseMiles = function (value) {
        this._triggerUseMiles.next(value);
    };
    INDRAMilesService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAMilesService_Factory() { return new INDRAMilesService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRAMilesService, providedIn: "root" });
    return INDRAMilesService;
}());
export { INDRAMilesService };
